<template>
  <div
    class='sim-container draggable'
    :style='ContainerStyle'
    ref='SimContainer'
    @click='Click'
    @mousedown='Down'
  >
    <div class='coordinates v-tooltip__content'>
    {{ -x }}, {{ -y }}
    </div>
    <div class='sim' :style='Style'>
      <Map :id='mapIdTest' v-if='mapIdTest != null' />

      <Character
        v-for='character in characters'
        :key='character.id'
        :id='character.id'
        draggable
        ref='characterEl' />

      <Entity
        v-for='entity in genericEntities'
        :key='entity.id'
        :id='entity.id'
        draggable
        ref='entityEl' />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import Character from './Character/index'
import Entity from './Entity/index'
import Map from './Map/Render'
import SimDraggable from '../Helpers/SimDraggable'
import DrawerNames from '@/Constants/Drawers'

export default {
  name: 'Sim',

  components: { Character, Entity, Map },

  data: function () {
    return {
      dragging: new SimDraggable(this)
    }
  },

  mounted() {
    this.dragging.init(this.$el)
  },

  destroyed() {
    this.dragging.destroy()
  },

  methods: {
    ...mapActions(['SetEntityFocus', 'SetCamera']),

    Click(e) {
      if (e.defaultPrevented) return

      e.preventDefault()
      this.SetEntityFocus()
    },

    Down(e) {
      if (e.currentTarget === e.target)
        this.SetEntityFocus()
    },

    Move(x, y) {
      this.SetCamera({
        x: this.x - x,
        y: this.y - y
      })
    }
  },

  computed: {
    ...mapState(['camera', 'background', 'drawerOpen', 'entities', 'mapIdTest', 'showGrid', 'gridOpacity', 'isDarkMode']),
    ...mapGetters(['characters', 'pets']),

    genericEntities() {
      const generic = ['pet', 'mob', 'npc']
      return Object
        .values(this.entities)
        .filter(entity => generic.indexOf(entity.type) != -1)
    },

    IsCharacterEditDrawerOpen() {
      return Object.values(DrawerNames.Character.Edit)
        .indexOf(this.drawerOpen) != -1
    },

    Style() {
      const style = {
        top: `${this.y}px`,
        left: `${this.x}px`
      }

      if (this.IsCharacterEditDrawerOpen)
        style['z-index'] = 10

      return style
    },

    ContainerStyle() {
      if (this.background && this.background.alpha)
        return {
          background: this.background.hexa
        }
      return {
        'background-position-x': `${this.x}px`,
        'background-position-y': `${this.y}px`,
        'background': `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23${this.isDarkMode ? 'FFFFFF' : '000000'}' fill-opacity='${this.showGrid ? (this.gridOpacity / 2) : 0}'%3E%3Cpath opacity='${this.showGrid ? this.gridOpacity : 0}' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
      }
    },

    x() { return this.camera.x },
    y() { return this.camera.y }
  }
}
</script>

<style lang="scss" scoped>
.sim-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  .sim {
    position: relative;

    .character {
      cursor: pointer;
    }
  }
}

.coordinates {
  position: fixed;
  top: 90px;
  right: 32px;
  z-index: 15;
}
</style>